module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#rss",
      toString: function () {
        return this.url;
      }
    }